import React, { FC } from "react";
import { ListItem } from "stentor-models";
import { reduceLink } from "./utils";
import "./Card.scss";

export interface CardProps {
    readonly item: ListItem;
    readonly className?: string;
}

export const Card: FC<CardProps> = props => {
    const { item } = props;

    const imageUrl = item.image?.url;

    return (
        <div className={`xapp-search-card ${props.className || ""}`}>
            {!!imageUrl &&
                <div className="xapp-search-card__featured">
                    <div className="xapp-search-card__featured-box">
                        <img
                            src={item.image?.url}
                            className="xapp-search-card__img"
                            alt={item.image?.accessibilityText}
                        />
                    </div>
                </div>
            }
            <div className="xapp-search-card__content">
                {!!item.url && <a href={item.url} className="xapp-search-card__title">
                    {item.title}
                </a>}
                {!!item.url && <div className="xapp-search-card__link">{reduceLink(item.url, 40)}</div>}
                <div className="xapp-search-card__description">
                    {item.description}
                </div>
            </div>
        </div>
    );
};